module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Bold.ttf?1b7c6a2a8acabe3c5dfc63c9c90b2880";